import React, { useState } from "react";
import { Check, Copy, Link2, Share2 } from "lucide-react";

// Link de convite da mesa, só pro anfitrião (pedido do dono, 23/09/2026).
// Quem abre o link e informa o CPF entra direto, sem esperar liberação. O
// código muda sozinho quando a mesa fecha e abre de novo, então o link de
// hoje não serve pra mesa de amanhã.
async function copiarTexto(texto) {
  try {
    await navigator.clipboard.writeText(texto);
    return true;
  } catch {
    // Navegador sem a API de área de transferência: o jeito antigo.
    const campo = document.createElement("textarea");
    campo.value = texto;
    campo.style.position = "fixed";
    campo.style.opacity = "0";
    document.body.appendChild(campo);
    campo.select();
    const ok = document.execCommand("copy");
    campo.remove();
    return ok;
  }
}

export default function ConviteMesa({ link, mesa, anfitriao }) {
  const [copiado, setCopiado] = useState(false);
  if (!link) return null;
  const nomeMesa = mesa?.nome || `Mesa ${mesa?.numero ?? ""}`;
  const mensagem = `${anfitriao ? `${anfitriao} te chamou pra ` : "Vem pra "}${nomeMesa}! Abre o link, informa seu CPF e pede direto pelo celular:`;

  const compartilhar = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: nomeMesa, text: mensagem, url: link });
        return;
      } catch (e) {
        if (e?.name === "AbortError") return; // a pessoa fechou a janela
      }
    }
    window.open(`https://wa.me/?text=${encodeURIComponent(`${mensagem} ${link}`)}`, "_blank", "noopener");
  };

  const copiar = async () => {
    if (await copiarTexto(link)) {
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2500);
    }
  };

  return (
    <div className="mt-6 rounded-2xl border-2 border-primary/30 bg-primary/5 p-4" data-e2e="mesa-convite" data-link={link}>
      <p className="font-black flex items-center gap-2">
        <Link2 className="w-5 h-5 text-primary" /> Convidar para a mesa
      </p>
      <p className="text-xs opacity-70 mt-1">
        Quem abrir este link entra direto, sem você precisar liberar. O link muda quando a mesa fechar.
      </p>
      <div className="mt-3 grid grid-cols-2 gap-2">
        <button type="button" onClick={compartilhar} data-e2e="mesa-convite-compartilhar"
          className="h-11 rounded-full bg-primary text-primary-foreground text-sm font-black flex items-center justify-center gap-1.5 active:scale-[0.98] transition">
          <Share2 className="w-4 h-4" /> Compartilhar
        </button>
        <button type="button" onClick={copiar} data-e2e="mesa-convite-copiar"
          className="h-11 rounded-full border-2 border-primary/40 text-primary text-sm font-bold flex items-center justify-center gap-1.5 active:scale-[0.98] transition">
          {copiado ? <><Check className="w-4 h-4" /> Copiado!</> : <><Copy className="w-4 h-4" /> Copiar link</>}
        </button>
      </div>
    </div>
  );
}
